module.exports = __webpack_public_path__ + "img/icon9.1feb2d60.png";